export default "__VITE_ASSET__CIBvN$4l__"